import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowIcon from "assets/images/down-arrow.svg";
import "./NavDropdown.scss";

interface Tab {
  key: string;
  label: string;
  path: string;
}

interface NavDropdownProps {
  title: string;
  tabs: Tab[];
  basePath: string;
  isActive: boolean;
}

const NavDropdown: React.FC<NavDropdownProps> = ({ title, tabs, basePath, isActive }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMainClick = () => {
    if (tabs.length > 0) {
      navigate(tabs[0].path);
    }
    setIsOpen(false);
  };

  const handleTabClick = (path: string) => {
    navigate(path);
    setIsOpen(false);
  };

  return (
    <div
      className="nav-dropdown"
      ref={dropdownRef}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}>
      <div
        className={`nav-dropdown-trigger ${isActive ? "nav-item-header-active" : ""}`}
        onClick={handleMainClick}>
        <span className="nav-item">{title}</span>
        <img
          src={ArrowIcon}
          alt="arrow"
          className={`nav-dropdown-arrow ${isOpen ? "nav-dropdown-arrow-open" : ""}`}
        />
      </div>
      {isOpen && tabs.length > 0 && (
        <div className="nav-dropdown-menu">
          {tabs.map((tab) => (
            <div
              key={tab.key}
              className={`nav-dropdown-item ${
                location.pathname + location.search === tab.path ? "nav-dropdown-item-active" : ""
              }`}
              onClick={() => handleTabClick(tab.path)}>
              {tab.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NavDropdown;
